<script lang="ts" setup>
import { ref } from 'vue'
import TariffsInterface from '@/components/tariffs/TariffsInterface.vue'
import { useI18n } from 'vue-i18n'

defineProps<{
  isRenewSheetOpen: boolean
  buttonText?: string
}>()
const emit = defineEmits(['close'])

const { t } = useI18n()

const close = () => {
  emit('close')
}

const startY = ref(0)

const onTouchStart = (event: TouchEvent) => {
  startY.value = event.touches[0].clientY
}

const onTouchMove = (event: TouchEvent) => {
  const deltaY = event.touches[0].clientY - startY.value
  if (deltaY > 100) {
    close()
  }
  event.preventDefault()
}
</script>

<template>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-if="isRenewSheetOpen"
        class="bottom-sheet-overlay"
        @click.self="close"
      >
        <div
          class="bottom-sheet d-flex flex-column ga-4"
          @touchmove="onTouchMove"
          @touchstart="onTouchStart"
        >
          <div class="bottom-sheet__wrapper">
            <div class="bottom-sheet__handle"></div>
          </div>
          <tariffs-interface :buttonText="buttonText || t('tariffs.renewSubscription')" />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.bottom-sheet-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(var(--v-theme-blur-overlay), var(--v-blur-overlay-opacity));
  backdrop-filter: blur(12px);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 100;
}

.bottom-sheet__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}

.bottom-sheet__handle {
  background-color: rgb(var(--v-theme-disabled));
  width: 70px;
  height: 2px;
}

.bottom-sheet {
  width: 100%;
  max-width: var(--app-max-width);
  background: rgb(var(--v-theme-background));
  border-radius: 16px 16px 0 0;
  padding-inline: 16px;
  box-shadow: 0 -4px 10px rgba(var(--v-theme-sheet-shadow), var(--v-sheet-shadow-opacity));
  padding-bottom: 32px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active .bottom-sheet,
.fade-leave-active .bottom-sheet {
  transition: transform 0.3s ease-out;
}

.fade-enter-from .bottom-sheet,
.fade-leave-to .bottom-sheet {
  transform: translateY(100%);
}
</style>
